import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-autocomplete-suffix-actions',
  standalone: false,
  templateUrl: './autocomplete-suffix-actions.component.html'
})
export class AutocompleteSuffixActionsComponent {
  @Input() showClear = false;
  @Input() clearDisabled = false;
  @Input() toggleDisabled = false;
  @Input() panelOpen = false;
  @Input() preserveClearSlot = false;
  @Input() clearAriaLabel = 'Clear';
  @Input() toggleAriaLabel = 'Toggle';

  @Output() clearClicked = new EventEmitter<Event>();
  @Output() toggleClicked = new EventEmitter<Event>();

  onClearClick(event: Event): void {
    this.clearClicked.emit(event);
  }

  onToggleClick(event: Event): void {
    this.toggleClicked.emit(event);
  }
}
